var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSilverMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4002_3089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8946 36.9245C14.3709 37.941 16.3302 39.5805 17.531 41.4387C17.7825 41.8279 17.4033 42.7516 16.9509 42.8519C14.7908 43.3304 12.2447 43.1205 9.76846 42.1039C7.29219 41.0874 5.33288 39.448 4.13209 37.5897C3.88062 37.2006 4.25984 36.2768 4.71219 36.1766C6.87219 35.698 9.41837 35.908 11.8946 36.9245Z",
    fill: "url(#paint0_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8946 36.9245C14.3709 37.941 16.3302 39.5805 17.531 41.4387C17.7825 41.8279 17.4033 42.7516 16.9509 42.8519C14.7908 43.3304 12.2447 43.1205 9.76846 42.1039C7.29219 41.0874 5.33288 39.448 4.13209 37.5897C3.88062 37.2006 4.25984 36.2768 4.71219 36.1766C6.87219 35.698 9.41837 35.908 11.8946 36.9245Z",
    fill: "url(#paint1_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1541 33.4131C15.5792 35.3351 17.2306 37.7837 17.9695 40.2323C18.1242 40.7451 17.4072 41.6498 16.8726 41.6162C14.32 41.4561 11.559 40.4076 9.13391 38.4855C6.70881 36.5635 5.05744 34.1149 4.31852 31.6663C4.16381 31.1535 4.88077 30.2489 5.41538 30.2824C7.96803 30.4426 10.729 31.491 13.1541 33.4131Z",
    fill: "url(#paint2_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1541 33.4131C15.5792 35.3351 17.2306 37.7837 17.9695 40.2323C18.1242 40.7451 17.4072 41.6498 16.8726 41.6162C14.32 41.4561 11.559 40.4076 9.13391 38.4855C6.70881 36.5635 5.05744 34.1149 4.31852 31.6663C4.16381 31.1535 4.88077 30.2489 5.41538 30.2824C7.96803 30.4426 10.729 31.491 13.1541 33.4131Z",
    fill: "url(#paint3_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6021 28.0022C17.727 31.2639 18.7186 34.8445 18.6217 38.0605C18.6014 38.7341 17.3847 39.5267 16.7605 39.2732C13.7795 38.0623 10.9049 35.7085 8.77998 32.4468C6.65507 29.1852 5.6635 25.6046 5.76037 22.3885C5.78066 21.715 6.99743 20.9223 7.62164 21.1758C10.6026 22.3867 13.4772 24.7405 15.6021 28.0022Z",
    fill: "url(#paint4_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1228 26.169C6.57927 28.2756 7.46104 30.4226 8.77986 32.4469C10.9048 35.7085 13.7793 38.0624 16.7604 39.2733C17.3847 39.5269 18.6013 38.7341 18.6216 38.0606C18.7186 34.8445 17.727 31.2639 15.602 28.0023C14.3507 26.0817 12.8395 24.4762 11.1997 23.2332L6.1228 26.169Z",
    fill: "url(#paint5_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1055 36.9245C35.6292 37.941 33.6699 39.5805 32.4691 41.4387C32.2177 41.8279 32.5969 42.7516 33.0492 42.8519C35.2093 43.3304 37.7554 43.1205 40.2317 42.1039C42.708 41.0874 44.6673 39.448 45.8681 37.5897C46.1195 37.2006 45.7403 36.2768 45.288 36.1766C43.128 35.698 40.5818 35.908 38.1055 36.9245Z",
    fill: "url(#paint6_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1055 36.9245C35.6292 37.941 33.6699 39.5805 32.4691 41.4387C32.2177 41.8279 32.5969 42.7516 33.0492 42.8519C35.2093 43.3304 37.7554 43.1205 40.2317 42.1039C42.708 41.0874 44.6673 39.448 45.8681 37.5897C46.1195 37.2006 45.7403 36.2768 45.288 36.1766C43.128 35.698 40.5818 35.908 38.1055 36.9245Z",
    fill: "url(#paint7_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8461 33.4131C34.421 35.3351 32.7696 37.7837 32.0307 40.2323C31.876 40.7451 32.5929 41.6498 33.1275 41.6162C35.6802 41.4561 38.4412 40.4076 40.8663 38.4855C43.2914 36.5635 44.9427 34.1149 45.6817 31.6663C45.8364 31.1535 45.1194 30.2489 44.5848 30.2824C42.0321 30.4426 39.2712 31.491 36.8461 33.4131Z",
    fill: "url(#paint8_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8461 33.4131C34.421 35.3351 32.7696 37.7837 32.0307 40.2323C31.876 40.7451 32.5929 41.6498 33.1275 41.6162C35.6802 41.4561 38.4412 40.4076 40.8663 38.4855C43.2914 36.5635 44.9427 34.1149 45.6817 31.6663C45.8364 31.1535 45.1194 30.2489 44.5848 30.2824C42.0321 30.4426 39.2712 31.491 36.8461 33.4131Z",
    fill: "url(#paint9_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.398 28.0022C32.2731 31.2639 31.2815 34.8445 31.3784 38.0605C31.3987 38.7341 32.6155 39.5267 33.2397 39.2732C36.2207 38.0623 39.0953 35.7085 41.2202 32.4468C43.3451 29.1852 44.3366 25.6046 44.2398 22.3885C44.2195 21.715 43.0027 20.9223 42.3785 21.1758C39.3975 22.3867 36.5229 24.7405 34.398 28.0022Z",
    fill: "url(#paint10_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8774 26.169C43.4209 28.2756 42.5391 30.4226 41.2203 32.4469C39.0954 35.7085 36.2209 38.0624 33.2398 39.2733C32.6155 39.5269 31.3988 38.7341 31.3785 38.0606C31.2816 34.8445 32.2732 31.2639 34.3982 28.0023C35.6494 26.0817 37.1607 24.4762 38.8005 23.2332L43.8774 26.169Z",
    fill: "url(#paint11_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 49.9999C33.6106 49.9999 40.5909 43.0197 40.5909 34.4091C40.5909 25.7986 33.6106 18.8184 25.0001 18.8184C16.3895 18.8184 9.4093 25.7986 9.4093 34.4091C9.4093 43.0197 16.3895 49.9999 25.0001 49.9999Z",
    fill: "url(#paint12_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 46.8361C31.8633 46.8361 37.427 41.2724 37.427 34.4091C37.427 27.5459 31.8633 21.9822 25.0001 21.9822C18.1369 21.9822 12.5731 27.5459 12.5731 34.4091C12.5731 41.2724 18.1369 46.8361 25.0001 46.8361Z",
    fill: "url(#paint13_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 45.0777C30.8922 45.0777 35.6687 40.3012 35.6687 34.4091C35.6687 28.517 30.8922 23.7405 25 23.7405C19.1079 23.7405 14.3314 28.517 14.3314 34.4091C14.3314 40.3012 19.1079 45.0777 25 45.0777Z",
    fill: "url(#paint14_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4093 34.4093C9.4093 43.0198 16.3895 50 25.0001 50C33.6107 50 40.5909 43.0198 40.5909 34.4093C40.5909 34.3488 40.5893 34.2887 40.5886 34.2283H9.41156C9.41087 34.2887 9.4093 34.3488 9.4093 34.4093Z",
    fill: "url(#paint15_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3727 49.3773C34.2854 47.9446 38.1946 44.1598 39.7998 39.3232L32.2064 31.7298L30.4945 31.8138L25.8743 27.1936L20.2434 40.248L29.3727 49.3773Z",
    fill: "url(#paint16_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.393 31.0215L28.3355 30.2828C28.0511 30.214 27.8025 30.0416 27.6385 29.7992L25.876 27.1938C25.6627 26.8787 25.3362 26.7096 25.0001 26.6824C24.664 26.7096 24.3373 26.8787 24.1242 27.1938L22.3616 29.7992C22.1977 30.0416 21.9492 30.214 21.6647 30.2828L18.6071 31.0215C17.7777 31.2219 17.4321 32.2118 17.9565 32.8849L19.8897 35.3663C20.0695 35.5972 20.1567 35.8868 20.1342 36.1786L19.8919 39.3147C19.8263 40.1654 20.6609 40.8001 21.4631 40.5093L24.4205 39.4376C24.6073 39.3698 24.8066 39.3524 25.0001 39.3824C25.1936 39.3525 25.3928 39.3699 25.5797 39.4376L28.537 40.5093C29.3392 40.8 30.1739 40.1654 30.1082 39.3147L29.866 36.1786C29.8434 35.8868 29.9307 35.5972 30.1105 35.3663L32.0437 32.8849C32.568 32.2118 32.2224 31.2219 31.393 31.0215Z",
    fill: "url(#paint17_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5797 39.4376L28.5371 40.5093C29.3392 40.8 30.1739 40.1654 30.1083 39.3147L29.866 36.1785C29.8435 35.8868 29.9307 35.5972 30.1105 35.3663L32.0438 32.8849C32.5682 32.2119 32.2225 31.2219 31.3931 31.0215L28.3355 30.2828C28.0511 30.214 27.8026 30.0416 27.6386 29.7992L25.876 27.1938C25.6628 26.8787 25.3362 26.7096 25.0001 26.6824V39.3824C25.1937 39.3524 25.393 39.3698 25.5797 39.4376Z",
    fill: "url(#paint18_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3931 31.0214L28.3355 30.2827C28.2311 30.2575 28.1317 30.218 28.0394 30.1665L20.2451 40.2482C20.5509 40.5437 21.0122 40.6728 21.4632 40.5093L24.4205 39.4376C24.6074 39.3698 24.8067 39.3524 25.0001 39.3824C25.1936 39.3525 25.3929 39.3699 25.5797 39.4376L28.5371 40.5093C29.3392 40.8 30.1739 40.1654 30.1083 39.3147L29.866 36.1786C29.8435 35.8868 29.9307 35.5972 30.1105 35.3663L32.0437 32.8849C32.5681 32.2117 32.2225 31.2218 31.3931 31.0214Z",
    fill: "url(#paint19_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6071 31.0214L21.6647 30.2827C21.7691 30.2575 21.8685 30.218 21.9608 30.1665L29.7551 40.2482C29.4493 40.5437 28.988 40.6728 28.537 40.5093L25.5797 39.4376C25.3928 39.3698 25.1935 39.3524 25.0001 39.3824C24.8065 39.3525 24.6073 39.3699 24.4205 39.4376L21.4631 40.5093C20.661 40.8 19.8263 40.1654 19.8919 39.3147L20.1342 36.1786C20.1567 35.8868 20.0695 35.5972 19.8897 35.3663L17.9565 32.8849C17.4321 32.2117 17.7777 31.2218 18.6071 31.0214Z",
    fill: "url(#paint20_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7933 31.73C17.6479 32.0966 17.6828 32.5336 17.9564 32.8849L19.8897 35.3663C20.0695 35.5971 20.1567 35.8867 20.1342 36.1785L19.8919 39.3147C19.8262 40.1654 20.6608 40.8001 21.4631 40.5093L24.4205 39.4375C24.6073 39.3698 24.8066 39.3523 25.0001 39.3823C25.1936 39.3524 25.3928 39.3699 25.5797 39.4375L28.537 40.5093C29.3392 40.8 30.1739 40.1654 30.1082 39.3147L29.8659 36.1785C29.8534 36.0166 29.8759 35.8558 29.928 35.7049L17.7933 31.73Z",
    fill: "url(#paint21_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2081 31.73C32.3535 32.0966 32.3187 32.5336 32.0449 32.8849L30.1117 35.3663C29.9319 35.5971 29.8446 35.8867 29.8672 36.1785L30.1094 39.3147C30.1751 40.1654 29.3404 40.8001 28.5383 40.5093L25.5809 39.4375C25.3941 39.3698 25.1947 39.3523 25.0013 39.3823C24.8078 39.3524 24.6086 39.3699 24.4217 39.4375L21.4643 40.5093C20.6622 40.8 19.8275 40.1654 19.8932 39.3147L20.1354 36.1785C20.148 36.0166 20.1255 35.8558 20.0734 35.7049L32.2081 31.73Z",
    fill: "url(#paint22_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 18.8184C24.9353 18.8184 24.8711 18.82 24.8066 18.8208L22.4005 21.2269L39.9653 38.7917C40.3718 37.4013 40.5908 35.9308 40.5908 34.409C40.5908 25.7986 33.6106 18.8184 25 18.8184Z",
    fill: "url(#paint23_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5884 0.32666V8.56195L25.0001 17.9737L34.4119 8.56195V0.32666H15.5884Z",
    fill: "url(#paint24_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5884 0.32666V2.8896L24.9687 12.2699C24.986 12.2872 25.0143 12.2872 25.0316 12.2699L34.4119 2.8896V0.32666H15.5884Z",
    fill: "url(#paint25_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5884 0.32666V2.8896L24.9687 12.2699C24.986 12.2872 25.0143 12.2872 25.0316 12.2699L34.4119 2.8896V0.32666H15.5884Z",
    fill: "url(#paint26_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 13.7528C24.6121 13.7528 24.2242 13.6051 23.9289 13.3097L15.5884 4.96924V8.56198L25.0001 17.9737L34.4119 8.56198V4.96924L26.0714 13.3097C25.7761 13.605 25.3882 13.7528 25.0001 13.7528Z",
    fill: "url(#paint27_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 13.7528C24.6121 13.7528 24.2242 13.6051 23.9289 13.3097L15.5884 4.96924V8.56198L25.0001 17.9737L34.4119 8.56198V4.96924L26.0714 13.3097C25.7761 13.605 25.3882 13.7528 25.0001 13.7528Z",
    fill: "url(#paint28_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 13.7528C25.3882 13.7528 25.7761 13.6051 26.0714 13.3097L34.4119 4.96924V8.56198L25.0001 17.9737L15.5884 8.56198V4.96924L23.9289 13.3097C24.2242 13.605 24.6122 13.7528 25.0001 13.7528Z",
    fill: "url(#paint29_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.968 15.8359L15.9588 7.82666C15.3582 7.22607 14.3844 7.22607 13.7838 7.82666C13.1832 8.42725 13.1832 9.40107 13.7838 10.0017L25.0001 21.2181L36.2165 10.0018C36.8171 9.40117 36.8171 8.42735 36.2165 7.82676C35.6159 7.22617 34.6421 7.22617 34.0415 7.82676L26.0322 15.836C25.4622 16.406 24.538 16.406 23.968 15.8359Z",
    fill: "url(#paint30_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7838 7.8449L23.8192 17.8803C24.4714 18.5325 25.529 18.5325 26.1812 17.8803L36.2165 7.8449C36.2195 7.84196 36.2218 7.83872 36.2248 7.83578C36.2219 7.83284 36.2195 7.8296 36.2165 7.82666C35.6159 7.22607 34.6421 7.22607 34.0415 7.82666L26.0323 15.8359C25.4623 16.4059 24.5381 16.4059 23.9681 15.8359L15.9589 7.82666C15.3583 7.22607 14.3845 7.22607 13.7839 7.82666C13.7809 7.8296 13.7786 7.83284 13.7756 7.83578C13.7785 7.83872 13.7808 7.84196 13.7838 7.8449Z",
    fill: "url(#paint31_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 21.2181L32.9176 13.3005H28.5675L26.0321 15.8359C25.4621 16.4059 24.5379 16.4059 23.9679 15.8359L21.4325 13.3005H17.0824L25 21.2181Z",
    fill: "url(#paint32_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0197 20.2376L25 21.218L35.0418 11.1763H30.6917L26.0322 15.8358C25.4788 16.3892 24.5926 16.4036 24.0197 15.8825V20.2376Z",
    fill: "url(#paint33_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 22.3037C27.0305 22.3037 28.6764 20.6578 28.6764 18.6274C28.6764 16.5971 27.0305 14.9512 25.0001 14.9512C22.9698 14.9512 21.3239 16.5971 21.3239 18.6274C21.3239 20.6578 22.9698 22.3037 25.0001 22.3037Z",
    fill: "url(#paint34_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 20.7351C26.1641 20.7351 27.1077 19.7914 27.1077 18.6274C27.1077 17.4634 26.1641 16.5198 25.0001 16.5198C23.8361 16.5198 22.8925 17.4634 22.8925 18.6274C22.8925 19.7914 23.8361 20.7351 25.0001 20.7351Z",
    fill: "url(#paint35_linear_4002_3089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8336 3.6601H14.1666C13.544 3.6601 13.0393 3.15539 13.0393 2.53284V1.12725C13.0393 0.504706 13.544 0 14.1666 0H35.8337C36.4562 0 36.9609 0.504706 36.9609 1.12725V2.53294C36.9609 3.15549 36.4562 3.6601 35.8336 3.6601Z",
    fill: "url(#paint36_linear_4002_3089)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4002_3089",
    x1: 9.04524,
    y1: 34.8433,
    x2: 10.8183,
    y2: 39.4626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4002_3089",
    x1: 8.1268,
    y1: 37.2568,
    x2: 12.0042,
    y2: 40.4792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5705,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4002_3089",
    x1: 7.04742,
    y1: 30.7758,
    x2: 10.7627,
    y2: 35.4582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4002_3089",
    x1: 7.96158,
    y1: 35.1476,
    x2: 11.4921,
    y2: 36.0298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5705,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4002_3089",
    x1: 11.9334,
    y1: 24.8505,
    x2: 12.3188,
    y2: 32.7894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4002_3089",
    x1: 11.341,
    y1: 28.9592,
    x2: 13.6495,
    y2: 32.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5705,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4002_3089",
    x1: 40.9593,
    y1: 34.8398,
    x2: 39.1862,
    y2: 39.4591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4002_3089",
    x1: 41.8778,
    y1: 37.2532,
    x2: 38.0004,
    y2: 40.4756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5705,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4002_3089",
    x1: 42.9572,
    y1: 30.7722,
    x2: 39.2419,
    y2: 35.4547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4002_3089",
    x1: 42.043,
    y1: 35.144,
    x2: 38.5125,
    y2: 36.0263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5705,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4002_3089",
    x1: 38.0711,
    y1: 24.8469,
    x2: 37.6857,
    y2: 32.7859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4002_3089",
    x1: 38.6636,
    y1: 28.9556,
    x2: 36.3552,
    y2: 32.3664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5705,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4002_3089",
    x1: 15.3877,
    y1: 24.7968,
    x2: 31.8305,
    y2: 41.2395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4002_3089",
    x1: 33.0713,
    y1: 42.4803,
    x2: 16.6934,
    y2: 26.1025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4002_3089",
    x1: 17.2443,
    y1: 26.6533,
    x2: 30.0106,
    y2: 39.4197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4002_3089",
    x1: 25.0001,
    y1: 38.9708,
    x2: 25.0001,
    y2: 49.2042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5705,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4002_3089",
    x1: 34.3376,
    y1: 42.5116,
    x2: 21.4617,
    y2: 34.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5705,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4002_3089",
    x1: 21.7524,
    y1: 31.4458,
    x2: 27.6089,
    y2: 37.3022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4002_3089",
    x1: 28.5092,
    y1: 33.0426,
    x2: 20.4148,
    y2: 36.3888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#678D98",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#678D98",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678D98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4002_3089",
    x1: 26.3958,
    y1: 35.915,
    x2: 21.9642,
    y2: 34.0157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#678D98",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#678D98",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678D98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4002_3089",
    x1: 23.6044,
    y1: 35.915,
    x2: 28.036,
    y2: 34.0157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#678D98",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#678D98",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678D98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4002_3089",
    x1: 23.7029,
    y1: 36.1373,
    x2: 26.5517,
    y2: 31.5588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#678D98",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#678D98",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678D98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4002_3089",
    x1: 26.0789,
    y1: 35.5591,
    x2: 25.8415,
    y2: 31.0823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#678D98",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#678D98",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678D98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4002_3089",
    x1: 32.6828,
    y1: 27.8227,
    x2: 26.6697,
    y2: 17.2998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5705,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4002_3089",
    x1: 25.6974,
    y1: 5.55637,
    x2: 29.5699,
    y2: 11.7328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4002_3089",
    x1: 21.8348,
    y1: -2.02167,
    x2: 33.8609,
    y2: 11.7691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4002_3089",
    x1: 25.0001,
    y1: 6.5195,
    x2: 25.0001,
    y2: 3.28088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0182FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1261,
    stopColor: "#017FF3",
    stopOpacity: 0.126
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3306,
    stopColor: "#0176DB",
    stopOpacity: 0.331
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5881,
    stopColor: "#0268B4",
    stopOpacity: 0.588
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8857,
    stopColor: "#02547E",
    stopOpacity: 0.886
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4002_3089",
    x1: 19.28,
    y1: 0.206101,
    x2: 31.3061,
    y2: 13.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4002_3089",
    x1: 28.7251,
    y1: 10.4905,
    x2: 30.3987,
    y2: 12.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0182FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1261,
    stopColor: "#017FF3",
    stopOpacity: 0.126
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3306,
    stopColor: "#0176DB",
    stopOpacity: 0.331
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5881,
    stopColor: "#0268B4",
    stopOpacity: 0.588
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8857,
    stopColor: "#02547E",
    stopOpacity: 0.886
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4002_3089",
    x1: 21.2751,
    y1: 10.4905,
    x2: 19.6016,
    y2: 12.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0182FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1261,
    stopColor: "#017FF3",
    stopOpacity: 0.126
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3306,
    stopColor: "#0176DB",
    stopOpacity: 0.331
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5881,
    stopColor: "#0268B4",
    stopOpacity: 0.588
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8857,
    stopColor: "#02547E",
    stopOpacity: 0.886
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4002_3089",
    x1: 33.4987,
    y1: 17.4128,
    x2: 13.3948,
    y2: -2.69108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4002_3089",
    x1: 25.0001,
    y1: 8.00647,
    x2: 25.0001,
    y2: 21.7358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4002_3089",
    x1: 25,
    y1: 15.9802,
    x2: 25,
    y2: 20.4944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5705,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4002_3089",
    x1: 29.6341,
    y1: 13.4242,
    x2: 26.889,
    y2: 16.2183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5705,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_4002_3089",
    x1: 22.8923,
    y1: 16.5196,
    x2: 28.0913,
    y2: 21.7186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_4002_3089",
    x1: 26.4952,
    y1: 20.1225,
    x2: 23.9216,
    y2: 17.5489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_4002_3089",
    x1: 25.0001,
    y1: 1.11108,
    x2: 25.0001,
    y2: 3.15402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4002_3089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverMedal);
export default __webpack_public_path__ + "static/media/silver-medal.3b2b782dd1eba04568445d8d824d2387.svg";
export { ForwardRef as ReactComponent };